<template>
	<nav>
		<ul class="topMenu">
			<li><p>+32(0)3 777 75 78</p></li>
			<li><a href="/files/Conscius Alg VW en AVG.pdf" download>Algemene en factuurvoorwaarden</a></li>
		</ul>
		<router-link to="/home"><div class="logo" alt="logo" /></router-link>


		<Slide right class="slide">
			<router-link to="/home">Home</router-link>
			<!-- <router-link to="/visie">Visie</router-link> -->
			<router-link to="/team">Team</router-link>
			<router-link to="/contact">Contact</router-link>
			<!-- <router-link to="/links">Links</router-link> -->
			<a href="/files/Conscius Alg VW en AVG.pdf" download>Download algemene voorwaarden</a>
		</Slide>
		
		<ul class="normalMenu">
			<li><router-link to="/home">Home</router-link></li>
			<!-- <li><router-link to="/visie">Visie</router-link></li> -->
			<li><router-link to="/team">Team</router-link></li>
			<li><router-link to="/contact">Contact</router-link></li>
			<!-- <li><router-link to="/links">Links</router-link></li> -->
		</ul>
	</nav>
</template>

<script>
	import {Slide} from 'vue-burger-menu';
	export default {
		name: 'Navigation',
		components: {Slide},
		data () {
			return {
				logo: require("../assets/logo3.png")
			}
		}
	}
</script>

<style lang="scss">
	@import '../sass/navigation.scss';
</style>
